import { FlowProvider, useNavigationFlow } from "@b2bportal/core-utilities";
import { TenantCarSteps } from "@tenant/types";

export const CoreCarSteps = {
  SEARCH: "SEARCH",
  AVAILABILITY: "AVAILABILITY",
  SHOP: "SHOP",
  BOOK: "BOOK",
};

export type CoreCarSteps = (typeof CoreCarSteps)[keyof typeof CoreCarSteps];

export const CarSteps = {
  ...CoreCarSteps,
  ...TenantCarSteps,
} as const;
export type CarSteps = (typeof CarSteps)[keyof typeof CarSteps];

export const CarNavigationFlowProvider = ({ children, navigationFlow }) => {
  return (
    <FlowProvider<CarSteps> flow={navigationFlow}>{children}</FlowProvider>
  );
};

export const useCarNavigationFlow = () => {
  const context = useNavigationFlow();
  if (context == null) {
    throw new Error("useFlow must be used within a CarNavigationFlow");
  }
  return context;
};
